import React, { useEffect, useState, useMemo, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Seo from "../../Components/SeoComponent/Seo";
import Header from "../../Components/Header";
import { SiTestcafe } from "react-icons/si";
import { GiClick } from "react-icons/gi";
import { fetchListOfService } from "../../Services/ServiceDocumentation/ServiceDoct";
import ConsentModal from "../../Components/Consent/ConsentModal";
import {
  verifyAcceptConsent,
  verifyAcceptedConsent,
  verifyViewConsent,
} from "../../Services/ApiTestService/apiTestService";
import { Loader2Icon } from "lucide-react";

function TestMaster() {
  const cards = [
    {
      title: "Basic Aadhar",
      img: "/assets/images/Aadhar.svg",
      link: "/TestAadhar",
      text: "",
      end_point: "\/srv2\/validation\/basic-aadhaar",
    },
    {
      title: "Pan Verification",
      img: "/assets/images/Pan.webp",
      link: "/TestPan",
      text: "",
      end_point: "\/pan\/verification",
    },
    {
      title: "Bank A/c verification Penny Less",
      img: "/assets/images/Bank.png",
      link: "/BankPennyTest",
      text: "",
      end_point: "\/bank-verification\/pennyless",
    },
    {
      title: "GSTIN Verification API",
      img: "/assets/images/GST.png",
      link: "/VerifyGST",
      text: "",
      end_point: "\/verify\/gstin",
    },
    {
      title: "MOBILE To Bank Find API",
      img: "/assets/images/MobBank.png",
      link: "/MobileToBank",
      text: "",
      end_point: "\/mobile-to-bank-details\/verification",
    },
    {
      title: "RC Verification API",
      img: "/assets/images/RC.png",
      link: "/RCVerify",
      text: "",
      end_point: "\/vehicle\/rc-verification",
    },
    {
      title: "DL Verification API",
      img: "/assets/images/DL.png",
      link: "/DLVerify",
      text: "",
      end_point: "\/verify\/driving-license",
    },
    {
      title: "Aadhar Pan Link Status",
      img: "/assets/images/AadharPan.webp",
      link: "/AadharPanLink",
      text: "",
      end_point: "\/check\/aadhar-pan-link",
    },
    {
      title: "E-Aadhar Download API",
      img: "/assets/images/AadharDown.png",
      link: "/aadhar/download",
      text: "",
      end_point: "\/aadhar\/download",
    },
    // {
    //   title: "Itr File Download",
    //   img: "/assets/images/ITRDown.png",
    //   link: "",
    //   text: "",
    //   end_point: "\/itr-file\/download",
    // },
    {
      title: "Company CIN Verify API",
      img: "/assets/images/CIN.png",
      link: "/company-cin/verification",
      text: "",
      end_point: "\/verify\/company-cin",
    },
    {
      title: "Verify Ration Card",
      img: "/assets/images/RationC.png",
      link: "/verify/ration-card",
      text: "",
      end_point: "\/verify\/ration-card",
    },
    {
      title: "ITR Compliance Check API",
      img: "/assets/images/ITRCom.png",
      link: "/itr/compliance-check",
      text: "",
      end_point: "\/itr\/compliance-check",
    },
    {
      title: "Simple UPI Verification",
      img: "/assets/images/UPISimp.png",
      link: "/upi-verification/simple",
      text: "",
      end_point: "\/upi-verification\/simple",
    },
    {
      title: "Advance UPI Verification",
      img: "/assets/images/UPIAdv.png",
      link: "/upi-verification/advance",
      text: "",
      end_point: "\/upi-verification\/advance",
    },
    {
      title: "Bank Statement Analysis",
      img: "/assets/images/BankV.png",
      link: "/bank-statement/analysis",
      text: "",
      end_point: "\/bank-statement\/analysis",
    },
    {
      title: "IFSC Code Verification",
      img: "/assets/images/Bank.png",
      link: "/ifsc-verify",
      text: "",
      end_point: "\/ifsc\/verify",
    },
    {
      title: "Pin Code Verification",
      img: "/assets/images/BankV.png",
      link: "/PinCodeVerify",
      text: "",
      end_point: "\/pincode\/verify",
    },
    {
      title: "Penny Drop Check Validation",
      img: "/assets/images/BankV.png",
      link: "/PennyDropCheckValidation",
      text: "",
      end_point: "\/srv2\/peeny-drop\/check-validation",
    },
    {
      title: "Penny Less Check Validation",
      img: "/assets/images/BankV.png",
      link: "/PennyLessCheckValidation",
      text: "",
      end_point: "\/srv2\/peeny-less\/check-validation",
    },
    {
      title: "Penny UPI Check Validation",
      img: "/assets/images/BankV.png",
      link: "/PennyUpiCheckValidation",
      text: "",
      end_point: "\/srv2\/peeny-upi-penny\/check-validation",
    },
    {
      title: "Eway Bill V2",
      img: "/assets/images/BankV.png",
      link: "/EwayBillV2",
      text: "",
      end_point: "\/srv2\/EwayBill\/verify",
    },
    {
      title: "Profile Fetch V2",
      img: "/assets/images/BankV.png",
      link: "/ProfileFetchV2",
      text: "",
      end_point: "\/profile-fetch-DetailsV2",
    },
    {
      title: "Mobile To UPI Advance Srv2",
      img: "/assets/images/BankV.png",
      link: "/MobileToUpiAdvanceSrv2",
      text: "",
      end_point: "\/srv2\/mobile-to-upi-advance",
    },
    {
      title: "FIR Check",
      img: "/assets/images/BankV.png",
      link: "/check-fir",
      text: "",
      end_point: "\/check\/FIR",
    },
    {
      title: "E Signer",
      img: "/assets/images/BankV.png",
      link: "/e-signer",
      text: "",
      end_point: "\/esign\/esigner",
    },
    {
      title: "RC Premium V2",
      img: "/assets/images/BankV.png",
      link: "/rc-premium-v2",
      text: "",
      end_point: "\/Rc-Premium-v2-verify",
    },
    {
      title: "RC Premium V1",
      img: "/assets/images/BankV.png",
      link: "/rc-premium-v1",
      text: "",
      end_point: "\/Rc-Premium-verify",
    },

    {
      title: "Bank Account Aggregator",
      img: "/assets/images/BankV.png",
      link: "/bank-account-aggregator",
      text: "",
      end_point: "\/Srv1\/bank-account-aggregator",
    },
  ];

  const cardsV2 = [
    {
      title: "Aadhar Verification(Srv2)",
      img: "/assets/images/Aadhar.svg",
      link: "/AadharV2",
      text: "",
      end_point: "\/srv2\/digital-kyc\/aadhar\/auto-verification",
    },
    {
      title: "Aadhar Verification Special(Srv2)",
      img: "/assets/images/Aadhar.svg",
      link: "/AadhaarSpecial",
      text: "",
      end_point: "\/srv2\/digital-kyc\/aadhar\/auto-verificationSpecial",
    },

    {
      title: "validation/pan/plus(Srv2)",
      img: "/assets/images/Pan.webp",
      link: "/verify/pan-plus",
      text: "",
      end_point: "\/srv2\/validation\/pan\/plus",
    },
    // { title: 'PAN Form Verification', img: '/assets/images/Pan.webp', link: '/verify/pan-form', text: '' },
    {
      title: "validation/voter(Srv2)",
      img: "https://cdn-icons-png.flaticon.com/128/5390/5390074.png",
      link: "/verify/voterid",
      text: "",
      end_point: "\/srv2\/validation\/voter",
    },
    {
      title: "validation/passport(Srv2)",
      img: "https://cdn-icons-png.flaticon.com/128/620/620686.png",
      link: "/verify/passportv2",
      text: "",
      end_point: "\/srv2\/validation\/passport",
    },
    {
      title: "validation/dl(Srv2)",
      img: "/assets/images/DL.png",
      link: "/verify/driving-licence",
      text: "",
      end_point: "\/srv2\/validation\/dl",
    },
    {
      title: "validation/dl-plus(Srv2)",
      img: "/assets/images/DL.png",
      link: "/verify/driving-licence-plus",
      text: "",
      end_point: "\/srv2\/validation\/dl-plus",
    },
    {
      title: "Digital KYC (Aadhar)  ",
      img: "/assets/images/Aadhar.svg",
      link: "/verify/digital-kyc",
      text: "",
      end_point: "\/srv2\/digital-kyc\/digilocker\/kyc",
    },
    // RC
    {
      title: "RC Verification V2",
      img: "/assets/images/RC.png",
      link: "/VehiclRCverify2",
      text: "",
      end_point: "\/vehicle\/rc-verification2",
    },
    // /verify/rc-validation
    // /VerifyRc
    // { title: 'RC Verification Srv2', img: '/assets/images/RC.png', link: '/verify/rc-validation', text: '' , end_point:'\/srv2\/validation\/rc' },
    {
      title: "RC Verification Srv2",
      img: "/assets/images/RC.png",
      link: "/VerifyRc",
      text: "",
      end_point: "\/srv2\/validation\/rc",
    },

    {
      title: "Chassis To RC Details (Srv2)",
      img: "/assets/images/RC.png",
      link: "/verify/rc-reverse-details",
      text: "",
      end_point: "\/srv2\/validation\/reverse-rc-details",
    },
    {
      title: "RC Verification Plus (Srv2)",
      img: "/assets/images/RC.png",
      link: "/verify/VerifyRCPlus",
      text: "",
      end_point: "\/srv2\/validation\/rc-plus",
    },
    // RC ENd
    // /VehiclRCverify2
    {
      title: "GST Basic",
      img: "/assets/images/GST.png",
      link: "/verify/basics/gst",
      text: "",
      end_point: "\/srv2\/validation\/kyb\/gst",
    },
    {
      title: "GST Advance",
      img: "/assets/images/GST.png",
      link: "/verify/advance/gst",
      text: "",
      end_point: "\/srv2\/validation\/kyb\/gst-advance",
    },
    {
      title: "Contact To GST",
      img: "/assets/images/GST.png",
      link: "/verify/contact-to-gst",
      text: "",
      end_point: "\/srv2\/validation\/kyb\/contact-to-gst",
    },
    {
      title: "GST To Mobile Number",
      img: "/assets/images/GST.png",
      link: "/verify/gst-to-contact",
      text: "",
      end_point: "\/srv2\/validation\/kyb\/gst-to-contacts",
    },
    {
      title: "Mobile To Name Finder",
      img: "/assets/images/MobBank.png",
      link: "/MobileToName",
      text: "",
      end_point: "\/srv2\/mobile-name-finder",
    },
    {
      title: "digital-profile-whatsapp-number-check(Srv2)",
      img: "/assets/images/MobBank.png",
      link: "/MobileToWhatsUp",
      text: "",
      end_point: "\/srv2\/digital-profile\/whatsapp-number-check",
    },
    {
      title: "mobile-to-udyam(Srv2)",
      img: "/assets/images/MobBank.png",
      link: "/MobileToUdyam",
      text: "",
      end_point: "\/srv2\/validation\/kyb\/mobile-to-udyam",
    },
    {
      title: "pan-to-udyam(Srv2)",
      img: "https://cdn-icons-png.flaticon.com/128/201/201623.png",
      link: "/PanToUdyam",
      text: "",
      end_point: "\/srv2\/validation\/kyb\/pan-to-udyam",
    },
    {
      title: "Common Account Detection (by Mobile) Srv2",
      img: "/assets/images/MobBank.png",
      link: "/MobileCheck",
      text: "",
      end_point: "\/srv2\/digital-profile\/mobile-check",
    },
    {
      title: "mobile-number-validation(Srv2)",
      img: "/assets/images/MobBank.png",
      link: "/MobileValidationBasic",
      text: "",
      end_point: "\/srv2\/mobile-number-validation",
    },
    {
      title: "mobile-number-validation/otp-based(Srv2)",
      img: "/assets/images/MobBank.png",
      link: "/MobileValidationOTP",
      text: "",
      end_point: "\/srv2\/mobile-number-validation\/otp-based",
    },
    {
      title: "mobile-upi-lookup/basic(Srv2)",
      img: "/assets/images/MobBank.png",
      link: "/MoblieUPILookUpBasic",
      text: "",
      end_point: "\/srv2\/mobile-upi-lookup\/basic",
    },
    {
      title: "mobile-upi-lookup/advance(Srv2)",
      img: "/assets/images/MobBank.png",
      link: "/MobileUPILookUpAdvance",
      text: "",
      end_point: "\/srv2\/mobile-upi-lookup\/advance",
    },
    {
      title: "mobile-upi-lookup/enhanced(Srv2)",
      img: "/assets/images/MobBank.png",
      link: "/MobileUPILookUpEnhance",
      text: "",
      end_point: "\/srv2\/mobile-upi-lookup\/enhanced",
    },
    {
      title: "Common Account Detection (by Email) Srv2",
      img: "/assets/images/ITRCom.png",
      link: "/EmailCheck",
      text: "",
      end_point: "\/srv2\/digital-profile\/email-check",
    },
    // { title: 'statement-analyzer', img: '/assets/images/BankV.png', link: '/StatementAnalyzer', text: '' , end_point:'\/srv2\/statement-analyzer' },
    {
      title: "Face Api Verification",
      img: "/assets/images/BankV.png",
      link: "/FaceApi",
      text: "",
      end_point: "\/srv2\/face-api\/match",
    },
    {
      title: "Liveness Verification",
      img: "/assets/images/BankV.png",
      link: "/FaceLiveness",
      text: "",
      end_point: "/srv2\/face-api\/liveness",
    },
    {
      title: "Face Detection (Srv2)",
      img: "/assets/images/BankV.png",
      link: "/facedetection",
      text: "",
      end_point: "/srv2\/face-api\/detection",
    },
    {
      title: "Pan Details V1 (Srv2)",
      img: "/assets/images/BankV.png",
      link: "/pandetailsV1",
      text: "",
      end_point: "/srv2\/validation\/pan\/father-details",
    },
    {
      title: "validation/pan(Srv2)",
      img: "/assets/images/Pan.webp",
      link: "/verify/panv2",
      text: "",
      end_point: "\/srv2\/validation\/pan",
    },
    {
      title: "Pan To Father Details (Srv2)",
      img: "/assets/images/BankV.png",
      link: "/pantofatherdetails",
      text: "",
      end_point: "/srv2\/validation\/pan\/to-father-name",
    },
    {
      title: "Pan Basic (Srv2)",
      img: "/assets/images/BankV.png",
      link: "/panbasic",
      text: "",
      end_point: "/srv2\/validation\/pan\/basic",
    },
    {
      title: "Pan Profile (Srv2)",
      img: "/assets/images/BankV.png",
      link: "/panprofile",
      text: "",
      end_point: "/srv2\/validation\/pan\/profile",
    },
    {
      title: "DIN To Contact",
      img: "/assets/images/BankV.png",
      link: "/dintocontact",
      text: "",
      end_point: "/srv3\/din\/director-phone-number",
    },
    {
      title: "Udyam Basic",
      img: "/assets/images/BankV.png",
      link: "/udyambasic",
      text: "",
      end_point: "/srv2\/validation\/kyb\/udyam\/basic",
    },
    {
      title: "Mobile to Udyam Lookup",
      img: "/assets/images/BankV.png",
      link: "/mobile-to-udyam-lookup",
      text: "",
      end_point: "/srv2\/validation\/kyb\/mobile-to-udyam-lookup",
    },
    {
      title: "Udyam Advance",
      img: "/assets/images/BankV.png",
      link: "/udyam-advance",
      text: "",
      end_point: "/srv2\/validation\/kyb\/udyam\/advance",
    },
    {
      title: "Rc To Mobile (Srv3)",
      img: "/assets/images/BankV.png",
      link: "/rc-to-mobile",
      text: "",
      end_point: "/srv3\/rc\/to-mobile",
    },
    // {title: 'Rc To Challan' , img:'/assets/images/BankV.png' , link: '/RCToChallan' , text: '', end_point: '\/srv3\/rc\/challan-details'},
    {
      title: "Challan Details (Srv3)",
      img: "/assets/images/BankV.png",
      link: "/rc-challan-details",
      text: "",
      end_point: "/srv3\/rc\/challan-details",
    },
    {
      title: "Aadhar Details (Srv3)",
      img: "/assets/images/Aadhar.svg",
      link: "/aadhar-details-verification",
      text: "",
      end_point: "/srv3\/verification\/aadhar",
    },
    {
      title: "Bank Verification Penny Drop",
      img: "/assets/images/Bank.png",
      link: "/bank-verification/pennyDrop",
      text: "",
      end_point: "\/bank-verification\/penny-drop",
    },
    {
      title: "Bank Verification Benny Validation",
      img: "/assets/images/Bank.png",
      link: "/bank-verification/bennyValidation",
      text: "",
      end_point: "\/idfc\/beneficiary",
    },
    {
      title: "Aadhar To Pan Details",
      img: "/assets/images/Aadhar.svg",
      link: "/aadhar-to-pan",
      text: "",
      end_point: "/srv3\/verification\/aadhar-to-pan",
    },
    {
      title: "Rc Verification Advance (Srv3)",
      img: "/assets/images/BankV.png",
      link: "/rc/advance-verification",
      text: "",
      end_point: "/srv3\/rc\/advance-verification",
    },
    {
      title: "RC Verification (Srv3)",
      img: "/assets/images/BankV.png",
      link: "/rc-verification",
      text: "",
      end_point: "/srv3\/rc\/verification",
    },
    {
      title: "Bank Verification Pennyless Advance",
      img: "/assets/images/Bank.png",
      link: "/bank-verification/penny-less-advance",
      text: "",
      end_point: "/bank-verification\/penny-less-advance",
    },
    {
      title: "Bank Verification Pennydrop Advance",
      img: "/assets/images/Bank.png",
      link: "/bank-verification/penny-drop-advance",
      text: "",
      end_point: "/bank-verification\/penny-drop-advance",
    },
    {
      title: "Din to Pan",
      img: "/assets/images/Bank.png",
      link: "/din-to-pan",
      text: "",
      end_point: "/srv2\/validation\/kyb\/din-to-pan",
    },
    {
      title: "Pan to Din",
      img: "assets/images/Pan.webp",
      link: "/pan-to-din",
      text: "",
      end_point: "/srv2\/validation\/kyb\/pan-to-din",
    },
    {
      title: "Gst Pan Search",
      img: "/assets/images/Pan.webp",
      link: "/gst-pan-search",
      text: "",
      end_point: "/srv2\/validation\/kyb\/gst-pan-search",
    },
    {
      title: "Digilocker Digital Kyc",
      img: "/assets/images/Pan.webp",
      link: "/digilocker/digital-kyc",
      end_point: "/srv2\/validation\/digilocker-digital-kyc",
    },
    {
      title: "Din to contact",
      img: "/assets/images/Pan.webp",
      link: "/dintocontact2",
      end_point: "\/srv2\/din\/to-contact",
    },
    {
      title: "verify consumer details",
      img: "/assets/images/Pan.webp",
      link: "/verifyConsumerDetails",
      end_point: "\/srv2\/credit-report\/consumer-details",
    },
    {
      title: "prefill",
      img: "/assets/images/Pan.webp",
      link: "/prefill",
      end_point: "\/srv2\/credit-report\/prefill",
    },
    {
      title: "prefillv2",
      img: "/assets/images/Pan.webp",
      link: "/prefillv2",
      end_point: "\/srv3\/credit-report\/prefill",
    },
    {
      title: "prefillv3",
      img: "/assets/images/Pan.webp",
      link: "/prefillv3",
      end_point: "\/srv3\/credit-report\/prefill-wn",
    },
    {
      title: "prefillv4",
      img: "/assets/images/Pan.webp",
      link: "/prefillv4",
      end_point: "\/srv4\/credit-report\/prefill",
    },
    {
      title: "Profile Fetch",
      img: "/assets/images/Pan.webp",
      link: "/ProfileFetch",
      end_point: "\/srv2\/profile-fetch",
    },
    {
      title: "Rc Card",
      img: "/assets/images/Pan.webp",
      link: "/rcCard",
      end_point: "\/srv3\/rc\/card",
    },

    {
      title: "Mobile to bank basic",
      img: "/assets/images/Pan.webp",
      link: "/MobileToBankBasic",
      end_point: "\/srv2\/mobile-to-bank\/basic",
    },

    {
      title: "Digilocker kyc",
      img: "/assets/images/Pan.webp",
      link: "/DigilockerKyc",
      end_point: "\/srv3\/digital-kyc\/digilocker\/kyc ",
    },
    {
      title: "Ocr Pan",
      img: "/assets/images/Pan.webp",
      link: "/ocr-pan",
      end_point: "\/ocr\/pan",
    },
    {
      title: "Ocr Aadhar",
      img: "/assets/images/Aadhar.svg",
      link: "/ocr-aadhar",
      end_point: "\/ocr\/aadhar",
    },
    {
      title: "Pan To Cin",
      img: "/assets/images/Pan.webp",
      link: "/PanToCin",
      end_point: "\/srv2\/validation\/kyb\/pan-to-cin",
    },
    {
      title: "Pan To bank Account",
      img: "/assets/images/Pan.webp",
      link: "/PanToBankAccount",
      end_point: "\/srv2\/pan\/to-bank-account",
    },
    {
      title: "Pan To Contact",
      img: "/assets/images/Pan.webp",
      link: "/PanToContact",
      end_point: "\/srv2\/pan\/to-contact",
    },
    {
      title: "basic-company-cin",
      img: "/assets/images/Pan.webp",
      link: "/BasicCompanyCin",
      end_point: "\/verify\/basic-company-cin",
    },
    {
      title: "Ocr Voter",
      img: "/assets/images/Pan.webp",
      link: "/OcrVoter",
      end_point: "\/ocr\/voter",
    },
    {
      title: "Ocr Passport",
      img: "/assets/images/Pan.webp",
      link: "/OcrPassport",
      end_point: "\/ocr\passport",
    },
    {
      title: "Ocr Driving Licence",
      img: "/assets/images/Pan.webp",
      link: "/OcrDl",
      end_point: "\/ocr\/dl",
    },
    {
      title: "Ocr Generic KYC Detection",
      img: "/assets/images/Pan.webp",
      link: "/OcrGenericKyc",
      end_point: "\/ocr\generic-kyc-detection",
    },
    {
      title: "Driving Licence Verification",
      img: "/assets/images/Pan.webp",
      link: "/DrivingLicence",
      end_point: "\/srv3\verification\/driving-licenses",
    },
    {
      title: "Rc Verification Full",
      img: "/assets/images/Pan.webp",
      link: "/RcVerificationFull",
      end_point: "\/vehicle\/rc-verification-full",
    },
    {
      title: "Upi Verification Advance",
      img: "/assets/images/Pan.webp",
      link: "/UpiVerificationAdvance",
      end_point: "\/srv2\/upi-verification/advance",
    },
    {
      title: "Upi Verification Enhance",
      img: "/assets/images/Pan.webp",
      link: "/MoblieUPILookUpEnhance",
      end_point: "\/srv2\/mobile-upi-lookup\/enhanced",
    },
    {
      title: "Upi Verification Simple V2",
      img: "/assets/images/Pan.webp",
      link: "/UpiBasicV2",
      end_point: "\/srv2\/upi-verification/simple",
    },
    {
      title: "Ovse Generate",
      img: "/assets/images/Pan.webp",
      link: "/ovse",
      end_point: "\/ovse\/generate-qr",
    },
    {
      title: "Challan Pro",
      img: "/assets/images/Pan.webp",
      link: "/ChallanPro",
      end_point: "\/car-info\/challan-pro",
    },
    {
      title: "Fastag Balance",
      img: "/assets/images/Pan.webp",
      link: "/FastagBalance",
      end_point: "\/car-info\/fastag-balance",
    },
    {
      title: "Rc Pro",
      img: "/assets/images/Pan.webp",
      link: "/RcPro",
      end_point: "\/srv3\/rc-pro",
    },
    {
      title: "Chasis To RC",
      img: "/assets/images/Pan.webp",
      link: "/ChasisToRc",
      end_point: "\/srv1\/chassis-to-rc",
    },
    {
      title: "Fastag Txn",
      img: "/assets/images/Pan.webp",
      link: "/FastagTxn",
      end_point: "\/srv1\/fastag-txn",
    },
    {
      title: "Mobile To Rc",
      img: "/assets/images/Pan.webp",
      link: "/MobileToRc",
      end_point: "\/srv1\/mobile-to-rc",
    },
    {
      title: "Rc To Mobile Srv1",
      img: "/assets/images/Pan.webp",
      link: "/RcToMobileSrv1",
      end_point: "\/srv1\/rc-to-mobile",
    },
    {
      title: "Engine To RC",
      img: "/assets/images/Pan.webp",
      link: "/EngineToRc",
      end_point: "\/srv1\/engine-to-rc",
    },
    {
      title: "Vehicle Valuation Pro",
      img: "/assets/images/Pan.webp",
      link: "/VehicleValuationPro",
      end_point: "\/srv1\/valuation-pro",
    },
    {
      title: "Vehicle Rc Lite",
      img: "/assets/images/Pan.webp",
      link: "/VehicleRcLite",
      end_point: "\/srv3\/rc-lite",
    },
    {
      title: "Vehicle Rc Logs",
      img: "/assets/images/Pan.webp",
      link: "/VehicleRcLogs",
      end_point: "\/srv1\/rc-logs",
    },
    {
      title: "Challan Pro Image",
      img: "/assets/images/Pan.webp",
      link: "/ChallanProImage",
      end_point: "\/srv1\/challan-pro-image",
    },
    {
      title: "Vehicle Service History",
      img: "/assets/images/Pan.webp",
      link: "/VehicleServiceHistory",
      end_point: "\/srv3\/vehicle-service-history",
    },
    {
      title: "Vehicle Pucc pro",
      img: "/assets/images/Pan.webp",
      link: "/VehiclePuccPro",
      end_point: "\/srv3\/pucc-pro",
    },
    {
      title: "Vehicle Ex Showroom",
      img: "/assets/images/Pan.webp",
      link: "/VehicleExShowroom",
      end_point: "\/srv3\/ex-showroom",
    },
    {
      title: "Vehicle Insurance Pro",
      img: "/assets/images/Pan.webp",
      link: "/VehicleInsurancePro",
      end_point: "\/srv3\/insurance-pro",
    },
    {
      title: "Fastag Status",
      img: "/assets/images/Pan.webp",
      link: "/FastagStatus",
      end_point: "\/srv1\/fastag-status",
    },
    {
      title: "Vehicle Fastag Mapper",
      img: "/assets/images/Pan.webp",
      link: "/VehicleFastagMapper",
      end_point: "\/srv1\/fastag-mapper",
    },
    {
      title: "Dl Licence",
      img: "/assets/images/Pan.webp",
      link: "/DlLicence",
      end_point: "\/srv1\/dl-license",
    },
    {
      title: "Basic E Challan",
      img: "/assets/images/Pan.webp",
      link: "/BasicEChallan",
      end_point: "\/srv2\/basic-e-challan",
    },
    {
      title: "UAN Mobile (srv2)",
      img: "/assets/images/Pan.webp",
      link: "/UanMobile",
      end_point: "\/srv2\/uan-mobile",
    },
    {
      title: "UAN Mobile (srv3)",
      img: "/assets/images/Pan.webp",
      link: "/UanMobileSrv3",
      end_point: "\/srv3\/uan-mobile",
    },
    {
      title: "UAN Name Dob (srv2)",
      img: "/assets/images/Pan.webp",
      link: "/UanNameDob",
      end_point: "\/srv2\/uan-name-dob",
    },
    {
      title: "UAN Direct (srv2)",
      img: "/assets/images/Pan.webp",
      link: "/UanDirect",
      end_point: "\/srv2\/uan-direct",
    },
    {
      title: "UAN Direct (srv3)",
      img: "/assets/images/Pan.webp",
      link: "/UanDirectSrv3",
      end_point: "\/srv3\/uan-direct",
    },
    {
      title: "UAN PAN (srv3)",
      img: "/assets/images/Pan.webp",
      link: "/UanPan",
      end_point: "\/srv3\/uan-pan",
    },
    {
      title: "UAN PAN Mobile (srv3)",
      img: "/assets/images/Pan.webp",
      link: "/UanPanMobilesrv3",
      end_point: "\/srv3\/uan-pan-mobile",
    },
    {
      title: "Aadhaar To Unmasked PAN",
      img: "/assets/images/Pan.webp",
      link: "/AadhaarToUnmaskedPan",
      end_point: "\/srv2\/validation\/aadhaar-to-unmasked-pan",
    },
    {
      title: "Verify GST Basic",
      img: "/assets/images/Pan.webp",
      link: "/VerifyGstBasic",
      end_point: "\/gst-verify\/basic",
    },
    {
      title: "Chassis To RC Details V2",
      img: "/assets/images/Pan.webp",
      link: "/ChasisToRcV2",
      end_point: "\/chassis-to-rc-detailsV2",
    },
    {
      title: "Kyc PAN Details",
      img: "/assets/images/Pan.webp",
      link: "/KycPanDetails",
      end_point: "\/srv2\/validation\/kyc\/pan-details",
    },
    {
      title: "RC To Mobile V2",
      img: "/assets/images/BankV.png",
      link: "/rc-to-mobile-srv2",
      text: "",
      end_point: "\/Srv2\/rc-to-mobile",
    },
    {
      title: "Mobile To RC V2",
      img: "/assets/images/BankV.png",
      link: "/mobile-to-rc-srv2",
      text: "",
      end_point: "\/Srv2\/mobile-to-rc",
    },
    {
      title: "RC Pro Masked",
      img: "/assets/images/BankV.png",
      link: "/rc-pro-masked",
      text: "",
      end_point: "\/Srv2\/rc-ProMasked",
    },
    {
      title: "RC Pro Unmasked",
      img: "/assets/images/BankV.png",
      link: "/rc-pro-unmasked",
      text: "",
      end_point: "\/Srv2\/rcProUnmasked",
    },
    {
      title: "E Challan V2",
      img: "/assets/images/BankV.png",
      link: "/e-challan-srv2",
      text: "",
      end_point: "\/Srv2\/eChallan",
    },
    {
      title: "RC Pro Cache",
      img: "/assets/images/BankV.png",
      link: "/rc-pro-cache",
      text: "",
      end_point: "\/Srv2\/rcProCache",
    },
    {
      title: "Challan Pro Srv2",
      img: "/assets/images/BankV.png",
      link: "/challan-pro-srv2",
      text: "",
      end_point: "\/Srv2\/challanPro",
    },
    {
      title: "Engine To RC Srv2",
      img: "/assets/images/BankV.png",
      link: "/engine-to-rc-srv2",
      text: "",
      end_point: "\/Srv2\/engine-to-rc",
    },
    {
      title: "Chassis To RC Srv2",
      img: "/assets/images/BankV.png",
      link: "/chassis-to-rc-srv2",
      text: "",
      end_point: "\/Srv2\/chassis-to-rc",
    },
    {
      title: "Vehicle Insurance Srv2",
      img: "/assets/images/BankV.png",
      link: "/vehicle-insurance-srv2",
      text: "",
      end_point: "\/Srv2\/insurance",
    },
    {
      title: "Vehicle FOP Details",
      img: "/assets/images/BankV.png",
      link: "/vehicle-fop-details",
      text: "",
      end_point: "\/Srv2\/mother-fop",
    },
    {
      title: "Mobile To Account Srv2",
      img: "/assets/images/BankV.png",
      link: "/mobile-to-account-srv2",
      text: "",
      end_point: "\/Srv2\/mobile-to-account",
    },
    {
      title: "RC Premium V3",
      img: "/assets/images/BankV.png",
      link: "/rc-premium-v3",
      text: "",
      end_point: "\/Srv2\/rcPremiumV3",
    },
    {
      title: "RC Premium V4",
      img: "/assets/images/BankV.png",
      link: "/rc-premium-v4",
      text: "",
      end_point: "\/Srv2\/rcPremiumV4",
    },
  ];

  const [serviceData, setServiceData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // consent states

  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [acceptConsentData, setAcceptConsentData] = useState(null);
  const [acceptedConsentData, setAcceptedConsentData] = useState(null);
  const [viewConsentData, setViewConsentData] = useState(null);
  const [startCounter, setStartCounter] = useState(false);
  const [triedFetchingConsentStatus, setTriedFetchingConsentStatus] =
    useState(false);
  const [triedFetchingViewStatus, setTriedFetchingViewStatus] = useState(false);
  const [isAlreadyAccepted, setIsAlreadyAccepted] = useState(false);
  const [isConsentLoading, setIsConsentLoading] = useState(true);
  const timeOutRef = useRef(null);
  const [isAccepting, setIsAccepting] = useState(false);
  const [isDeclining, setIsDeclining] = useState(false);
  const [timer, setTimer] = useState(5);
  const intervalRef = useRef(null);
  const [isAllowed, setIsAllowed] = useState(false);

  const navigate = useNavigate();

  useMemo(() => {
    const retrieveServiceData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchListOfService();
        setServiceData(response?.data || []); //  response.data is an array
        // console.log("Fetched service data:", response?.data || []);
      } catch (error) {
        console.error("Error fetching service data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    retrieveServiceData();
  }, []);

  const getServiceValue = (endPoint) => {
    const service = findService(endPoint);
    return service?.service_value ?? "-";
  };

  // Find service by end_point
  const findService = (endPoint) => {
    if (!endPoint) return null;
    const normalizedEndPoint = endPoint.trim().toLowerCase();

    return (
      serviceData.find(
        (s) => s?.end_point?.trim().toLowerCase() === normalizedEndPoint,
      ) || null
    );
  };

  const isAssigned = (endPoint) => {
    const service = findService(endPoint);
    if (service?.assigned === true) return true;
    if (service?.assigned === false) return false;
    return null; // not present
  };

  // NEW: get label to show on card
  const getServiceName = (card) => {
    const service = findService(card.end_point);
    return service?.service_name || card.title;
  };

  // ADD THIS: Handle card click
  const handleCardClick = (card) => {
    navigate(card.link, {
      state: {
        serviceName: getServiceName(card),
        serviceValue: getServiceValue(card.end_point),
        endPoint: card.end_point,
      },
    });
  };

  const getStatus = (endPoint) => {
    const service = findService(endPoint);
    return service?.status || null;
  };

  const getStatusBadge = (status) => {
    if (!status) return null;

    const s = status.toLowerCase();

    const colors = {
      active: "bg-green-600 text-white",
      inactive: "bg-red-600 text-white",
      deprecated: "bg-yellow-600 text-black",
    };

    return (
      <span
        className={`text-[10px] px-1 py-[1px] rounded-full font-semibold ${colors[s] || "bg-gray-500 text-white"}`}
      >
        {status}
      </span>
    );
  };

  const filteredCards = cards.filter((card) =>
    getServiceName(card).toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const filteredCardsV2 = cardsV2.filter((card) =>
    getServiceName(card).toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const fetchViewDetails = async () => {
    try {
      setIsConsentLoading(true);
      const response = await verifyViewConsent();

      if (response) {
        setViewConsentData(response);
        setIsConsentLoading(false);
        setTriedFetchingViewStatus(true);
      } else {
        setErrorMessage(response?.data?.message);
        setIsConsentLoading(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsConsentLoading(false);
    }
  };

  const fetchConsentStatus = async () => {
    try {
      setIsConsentLoading(true);
      setTriedFetchingConsentStatus(true);

      const res = await verifyAcceptedConsent(1);

      if (res?.data?.consented) {
        setAcceptedConsentData(res);
        setSuccessMessage(res?.data?.message);
        setIsConsentLoading(false);
        setIsAlreadyAccepted(true);
      } else {
        setErrorMessage(res?.data?.message);
      }
    } catch (error) {
      console.error(error);
      setIsConsentLoading(false);
    } finally {
      setIsConsentLoading(false);
    }
  };

  const startTimer = (type) => {
    setIsDeclining(type === "decline");
    setStartCounter(true);
    setTimer(5);

    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);

          if (type === "decline") {
            navigate("/Dashboard");
          } else {
            setIsAlreadyAccepted(true);
            setIsAllowed(true);
          }

          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleConsent = async (type) => {
    if (type !== "agree") {
      startTimer("decline");
      return;
    }

    try {
      setIsLoading(true);

      const res = await verifyAcceptConsent(viewConsentData?.data?.id);

      if (!res?.data?.consented) {
        setErrorMessage(res?.data?.message);
        return;
      }

      setAcceptConsentData(res);
      setSuccessMessage(res?.data?.message);
      setIsAccepting(true);
      startTimer("agree");
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchViewDetails();
  }, []);

  useEffect(() => {
    if (!viewConsentData || triedFetchingConsentStatus) return;

    fetchConsentStatus();
  }, [viewConsentData, triedFetchingConsentStatus]);

  const hasConsent =
    acceptedConsentData?.data?.consented === true ||
    acceptConsentData?.data?.consented === true;

  const isConsentResolved =
    acceptConsentData !== undefined && acceptedConsentData !== undefined;

  if (isConsentLoading || !isConsentResolved) {
    return (
      <>
        <Seo />
        <Header heading="Test API" />
        <div className="flex h-screen w-full justify-center items-center">
          <Loader2Icon className="animate-spin" />
        </div>
      </>
    );
  }

  if (
    triedFetchingViewStatus &&
    triedFetchingConsentStatus &&
    !isAlreadyAccepted &&
    !isAllowed &&
    !isConsentLoading
  ) {
    return (
      <>
        <Seo />
        <Header heading="Test API" />
        <div className="flex h-screen justify-center items-start">
          <ConsentModal
            handleConsent={handleConsent}
            isLoading={isConsentLoading}
            startCounter={startCounter}
            errorMessage={errorMessage}
            successMessage={successMessage}
            acceptConsentData={acceptConsentData}
            viewConsentData={viewConsentData}
            isAlreadyAccepted={isAlreadyAccepted}
            isAccepting={isAccepting}
            isDeclining={isDeclining}
            timer={timer}
          />
        </div>
      </>
    );
  }

  return (
    <>
      <Seo />
      <Header heading="Test API" />

      {/* Search */}
      <div className="flex justify-center my-4">
        <input
          type="text"
          placeholder="🔍 Search services..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-1/2 border border-blue-500 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none shadow-sm"
        />
      </div>

      <hr className="border border-blue-600 mt-1 mb-1" />

      <div className=" grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Server 1 */}
        <div className="">
          <div className="flex justify-center mb-2">
            <h3 className="text-center text-white font-semibold text-md bg-pink-500 rounded-md px-1 py-1">
              Services (Server 1)
            </h3>
          </div>

          {/* Single Parent Card Container */}
          <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
            {filteredCards.map((card, index) => {
              const assignedStatus = isAssigned(card.end_point);
              return (
                <div
                  key={index}
                  className={`px-2 py-2 hover:bg-blue-50 transition-colors ${
                    index !== filteredCards.length - 1
                      ? "border-b border-gray-200"
                      : ""
                  }`}
                >
                  {/* Main Row: Icon, Name, Button, Statuses */}
                  <div className="flex items-center gap-3">
                    {/* Icon */}
                    <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                      {card.img ? (
                        <img
                          src={card.img}
                          alt={getServiceName(card)}
                          className="h-6 w-6 object-contain"
                        />
                      ) : (
                        <SiTestcafe className="text-blue-500 text-xl" />
                      )}
                    </div>

                    {/* Name Only */}
                    <div className="flex-grow min-w-0">
                      <h3 className="text-sm font-semibold text-gray-800 truncate">
                        {getServiceName(card)}
                      </h3>
                    </div>

                    {/* Try Now Button */}
                    <Link
                      to={card.link}
                      state={{ serviceName: getServiceName(card) }}
                      className="flex-shrink-0 inline-flex items-center gap-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-3 py-1 text-xs rounded shadow transition whitespace-nowrap"
                    >
                      Try Now <GiClick size={16} className="animate-pulse" />
                    </Link>

                    {/* Status Badge (from getStatus) */}
                    {getStatus(card.end_point) && (
                      <div className="flex-shrink-0">
                        {getStatusBadge(getStatus(card.end_point))}
                      </div>
                    )}

                    {/* Assigned Status Badge */}
                    <div className="flex-shrink-0 w-20">
                      <span
                        className={`inline-block w-full text-center text-xs font-medium px-2 py-0.5 rounded whitespace-nowrap ${
                          assignedStatus === true
                            ? "text-green-700 bg-green-100"
                            : assignedStatus === false
                              ? "text-red-600 bg-red-100"
                              : "text-yellow-600 bg-yellow-100"
                        }`}
                      >
                        {assignedStatus === true
                          ? "Assigned"
                          : assignedStatus === false
                            ? "Not Assigned"
                            : "Not Added"}
                      </span>
                    </div>
                  </div>

                  {/* Description - Full Width New Line */}
                  <div className="w-full pl-0">
                    <p className="text-xs text-gray-600 leading-relaxed">
                      <span className="font-medium text-gray-700">
                        Description:
                      </span>{" "}
                      {getServiceValue(card.end_point)}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* <div className="border-l-2 border-blue-600"></div> */}

        {/* Server 2 */}
        <div className="">
          <div className="flex justify-center mb-1">
            <h3 className="text-center text-white font-semibold text-md bg-pink-500 rounded-md px-1 py-1">
              New Services (Server 2)
            </h3>
          </div>

          {/* Single Parent Card Container */}
          <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
            {filteredCardsV2.map((card, index) => {
              const assignedStatus = isAssigned(card.end_point);
              return (
                <div
                  key={index}
                  className={`px-2 py-2 hover:bg-blue-50 transition-colors ${
                    index !== filteredCardsV2.length - 1
                      ? "border-b border-gray-200"
                      : ""
                  }`}
                >
                  {/* Main Row: Icon, Name, Service Value, Button, Statuses */}
                  <div className="flex items-center gap-3">
                    {/* Icon */}
                    <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                      {card.img ? (
                        <img
                          src={card.img}
                          alt={getServiceName(card)}
                          className="h-6 w-6 object-contain"
                        />
                      ) : (
                        <SiTestcafe className="text-blue-500 text-xl" />
                      )}
                    </div>

                    {/* Name Only */}
                    <div className="flex-grow min-w-0">
                      <h3 className="text-sm font-semibold text-gray-800 truncate">
                        {getServiceName(card)}
                      </h3>
                    </div>

                    {/* Try Now Button */}
                    <Link
                      to={card.link}
                      state={{ serviceName: getServiceName(card) }}
                      className="flex-shrink-0 inline-flex items-center gap-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-3 py-1 text-xs rounded shadow transition whitespace-nowrap"
                    >
                      Try Now <GiClick size={16} className="animate-pulse" />
                    </Link>

                    {/* Status Badge (from getStatus) */}
                    {getStatus(card.end_point) && (
                      <div className="flex-shrink-0">
                        {getStatusBadge(getStatus(card.end_point))}
                      </div>
                    )}

                    {/* Assigned Status Badge */}
                    <div className="flex-shrink-0 w-20">
                      <span
                        className={`inline-block w-full text-center text-xs font-medium px-2 py-0.5 rounded whitespace-nowrap ${
                          assignedStatus === true
                            ? "text-green-700 bg-green-100"
                            : assignedStatus === false
                              ? "text-red-600 bg-red-100"
                              : "text-yellow-600 bg-yellow-100"
                        }`}
                      >
                        {assignedStatus === true
                          ? "Assigned"
                          : assignedStatus === false
                            ? "Not Assigned"
                            : "Not Added"}
                      </span>
                    </div>
                  </div>

                  {/* Description - Full Width New Line */}
                  <div className="w-full pl-0 pt-0">
                    <p className="text-xs text-gray-600 leading-relaxed">
                      <span className="font-medium text-gray-700">
                        Description:
                      </span>{" "}
                      {getServiceValue(card.end_point)}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default TestMaster;
